import './new-faq.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateFaq } from "@core/query/faq.query";
import { FaqFormRule, FaqFormSchema } from "@core/form/form.rule";
import { faqFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormFaq from "../form-faq/form-faq";

export function NewFaq() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateFaq } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Faq is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addFaq, isLoading: isCreating } =
    useQyCreateFaq(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<FaqFormSchema>({
    defaultValues: faqFormDefault,
    resolver: zodResolver(FaqFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: FaqFormSchema) => {
    const formData = mapCreateFaq(form);
    addFaq(formData);
  };
  const handleValidateError = (err: FieldErrors<FaqFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="Faq" className="faq">
      <HeaderContent
        title="New Tutorial"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormFaq />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewFaq;